import { Translations } from "../../../localization/Translations";
import { CourseFormat } from "../../../models/courses/CourseFormat";

export const getCourseFormat = (format: string, translations: Translations) => {
  switch (format) {
    case CourseFormat.Online:
      return translations.courseFormatOnline!;

    case CourseFormat.Classroom:
      return translations.courseFormatClassroom!;

    case CourseFormat.Blended:
      return translations.courseFormatBlended!;

    default:
      return "";
  }
};
